import {ICampaignBudget} from "../../../../model/campaign/ICampaignsBudgetRanges";

export const initialBudgetRange: ICampaignBudget = {
    nbPlatforms: 0,
    minPrice: 0,
    maxPrice: 0,
    recommendedMaxBudget: 0,
    recommendedMinBudget: 0,
    creatorType: undefined
}